export default "__VITE_ASSET__C4PxafX7__"